/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Tile_Livechat_DescInputs */

const tr_landing_community_tile_livechat_desc = /** @type {(inputs: Landing_Community_Tile_Livechat_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masaüstü panelde yazın; yapay zeka asistanımız 7/24 yanıt verir. Geçmiş oturumlar kaydedilir.`)
};

const en_landing_community_tile_livechat_desc = /** @type {(inputs: Landing_Community_Tile_Livechat_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message us in the panel on desktop; our AI assistant answers 24/7. Past sessions are saved.`)
};

const de_landing_community_tile_livechat_desc = /** @type {(inputs: Landing_Community_Tile_Livechat_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreiben Sie im Panel am Desktop; unser KI-Assistent antwortet rund um die Uhr. Frühere Sitzungen werden gespeichert.`)
};

const ru_landing_community_tile_livechat_desc = /** @type {(inputs: Landing_Community_Tile_Livechat_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пишите в панели на компьютере; наш ИИ-ассистент отвечает 24/7. История сессий сохраняется.`)
};

/**
* | output |
* | --- |
* | "Message us in the panel on desktop; our AI assistant answers 24/7. Past sessions are saved." |
*
* @param {Landing_Community_Tile_Livechat_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_tile_livechat_desc = /** @type {((inputs?: Landing_Community_Tile_Livechat_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Tile_Livechat_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_tile_livechat_desc(inputs)
	if (locale === "de") return de_landing_community_tile_livechat_desc(inputs)
	if (locale === "ru") return ru_landing_community_tile_livechat_desc(inputs)
	return tr_landing_community_tile_livechat_desc(inputs)
});